<template>
<v-col v-if="demandes">
  <v-form lazy-validation ref="formInsee" v-model="validFormInsee" @submit.prevent v-if="demandes.length == 0 || demandes[demandes.length-1].validation != null">
    <v-file-input
      label="Nouveau document insee"
      :rules="[
        (value) => !!value || 'Champ requis.',
        (value) =>
          (!!value &&
            /^.+\.(pdf|png|jpg|jpeg)$/.test(value.name.toLowerCase())) ||
          'Format incorrect. Formats acceptés : pdf, png, jpg, jpeg.',
      ]"
      accept=".pdf, .png, .jpg, .jpeg"
      v-model="insee.nameFile"
    >
    </v-file-input>
    <v-text-field
      name="numero"
      label="insee"
      v-model="insee.insee"
      maxlength="15"
      minlength="15"
      :rules="[(value) => !!value || 'Champ requis.', (value) => /^[^ ]+$/.test(value)  || 'Les espaces sont prohibés !!',(value) => /^[0-9A-B]+$/.test(value) || 'Seulement les chiffres sont acceptés !', (value) => /^.{15}$/.test(value) || 'Caractère(s) manquant(s) (15 au total).']"
    ></v-text-field>
    <v-btn
      class="mx-2"
      :disabled="!validFormInsee"
      color="success"
      @click="validerFormInsee"
      ><v-icon left>mdi-magnify</v-icon>Valider</v-btn
    >
  </v-form>

  <v-data-table v-if="demandes" :headers="headers" :items="demandes">
<template v-slot:[`item.validation`]="{ item }">
        <v-chip v-if="item.validation == null" color="warning">
          en cours
        </v-chip>
        <v-chip v-else-if="item.validation == 0" color="error">refusé</v-chip>
        <v-chip v-else-if="item.validation == 1" color="success"
          >accepté</v-chip
        >
      </template>
    </v-data-table>
    </v-col>
</template>

<script>
import ApiInseeRepository from "@/repositories/ApiInseeRepository";

export default {
  data() {
    return {
      validFormInsee: false,
      insee: 
      {
          nameFile: null,
          insee: null,
          validation: null
      },
           headers: [
        {
          text: "Numéro",
          value: "id",
        },
        {
          text: "Nom du fichier",
          value: "nameFile",
        },
        {
          text: "Statut",
          value: "validation",
        },
        {
          text: "Insee",
          value: "numero"
        },
        {
          text: "Message de refus",
          value: "messageRefus"
        }
      ],
      demandes: null
    };
  },
  async created()
  {
    this.demandes = await ApiInseeRepository.getDemandes();
  },
  methods: {
    validerFormInsee() {
      if (this.$refs.formInsee.validate()) {
        if(this.isInseeValid(this.insee.insee))
        {
        this.$confirm(
          "<strong>ATTENTION, en validant ce dossier vous ne pourrez plus le modifier. " +
            "Cliquez sur 'Oui' pour confirmer votre demande ou sur 'Non' pour revenir à l'écran précédent.</strong>"
        ).then(
          ( async (response) => {
              console.log(this.insee)
            this.demandes.push(await ApiInseeRepository.saveInsee(this.insee));
          })
        );
      }
      else
      {
        alert("aie le numéro de sécurité sociale est mauvais");
      }
      }
      
    },
    isInseeValid(insee)
    {
        var departement = insee.slice(5,7);
        if(departement = "2A")
        {
            departement = "19";
            insee = insee.replace("2A",departement);
        }
        else if(departement = "2B")
        {
            departement = "18";
            insee = insee.replace("2B",departement);
        }
        var inseeWithoutKey = insee.slice(0,13);
        console.log(inseeWithoutKey);
        var key = (97 - (parseInt(inseeWithoutKey,10) % 97));
        console.log(key);
        return key == insee.slice(-2);

    }
  },
};
</script>